import { defineMessages } from 'react-intl';

export default defineMessages({
	upsellBannerAriaLabel: {
		id: 'app.ui.upsell.aria',
		defaultMessage: 'Calm Premium Offer Banner',
		description: 'The label description for the upsell banner',
	},
});
